import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faHourglassEnd, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Card, Col, Container, Row } from 'reactstrap';

import $ from 'jquery';

import SmokeCenter from '../components/SmokeCenter';
import Eagle from '../components/Eagle';
import Leaves from '../components/Leaves';
import FaqReferralContestModal from '../components/FaqReferralContestModal';

import winIcon from '../../img/win_icon.png';
import waitIcon from '../../img/wait_icon.png';
import warningIcon from '../../img/warn_icon.png';
import ReactTooltip from 'react-tooltip';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import trumpet from '../../img/trumpet.png';

class ReferralContest extends Component {

  constructor(props) {
    super(props);

    this.state = {
      referralContest: null,
      copied: false
    };
  };

  componentDidMount() {
    this.setState({
      referralContest: null
    });
    if (this.props.match.params.referralContestId) {
      this.getDataReferralContest();
      if (process.env.REACT_APP_GAME_AUTOREFRESH_TIMEOUT) {
        this.timerGetData = setInterval(() => {
          this.getDataReferralContest();
        }, process.env.REACT_APP_GAME_AUTOREFRESH_TIMEOUT);
      }
    }

    //mover el tiempo de cada sala
    this.timerTime = setInterval(() => {
      this.moveTime();
    }, 1000);
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.match.params.referralContestId !== nextProps.match.params.referralContestId) {
      this.props = nextProps;
      this.componentDidMount();
    }
    return true;
  }

  componentWillUnmount() {
    clearInterval(this.timerGetData);
    clearInterval(this.timerTime);
  };

  getDataReferralContest() {
    let clase = this;
    fetch(clase.props.urlGlobal + "api/competenciaReferido", {
      method: "POST",
      body: JSON.stringify({
        action: "getPosiciones",
        id: clase.props.match.params.referralContestId,
        lan: clase.props.getLanActual()
      }),
      headers: clase.props.getHeadersToSend()
    }).then(function (response) {
      return response.json();
    }).then(function (result) {
      if (result.success) {
        clase.setState({
          referralContest: result.competencia
        });
      }
    });
  };

  moveTime() {
    let referralContest = this.state.referralContest;
    if (referralContest) {
      let dias = referralContest.tiempo.dias;
      let horas = referralContest.tiempo.horas;
      let minutos = referralContest.tiempo.minutos;
      let segundos = referralContest.tiempo.segundos;

      segundos--;
      if (segundos < 0) {
        if (minutos > 0) {
          segundos = 59;
          minutos--;
        }
        else {
          segundos = 0;
        }
      }
      if (minutos < 0) {
        if (horas > 0) {
          minutos = 59;
          horas--;
        }
        else {
          minutos = 0;
        }
      }
      if (horas < 0) {
        if (dias > 0) {
          horas = 23;
          dias--;
        }
        else {
          horas = 0;
        }
      }
      if (dias < 0) {
        dias = 0;
      }

      referralContest.tiempo = {
        dias: dias,
        horas: horas,
        minutos: minutos,
        segundos: segundos
      };

      this.setState({
        referralContest: referralContest
      });
    }
  };

  showAceptGeneralJackpot(generaljackpot) {
    if (this.props.loggedIn) {
      if (generaljackpot !== null && !generaljackpot.type) {
        this.props.referralContestModalElement.current.setState({
          referralContest: generaljackpot
        });
        $(".mt_block.step_4").fadeOut(0);
        $(".mt_block.step_5").fadeOut(0);
        $("#referral_contest_modal_overlay").fadeIn("fast", function () {
          $("#referral_contest_modal").fadeIn("fast", function () {
            document.body.style.overflow = "hidden";
          });
        });
      } else if (generaljackpot !== null && generaljackpot.type) {
        this.props.generaljackpotModalElement.current.setState({
          generaljackpot: generaljackpot
        });
        $(".mt_block.step_4").fadeOut(0);
        $(".mt_block.step_5").fadeOut(0);
        $("#generaljackpot_modal_overlay").fadeIn("fast", function () {
          $("#generaljackpot_modal").fadeIn("fast", function () {
            document.body.style.overflow = "hidden";
          });
        });
      }
      else {
        alert(this.props.textosShow.estamodalidadnoestaaundisponible || "Esta modalidad no esta aún disponible");
      }
    }
    else {
      alert(this.props.textosShow.paraaccederajugardebeestarregistradoconunacuenta || "Para acceder a jugar debe estar registrado con una cuenta");
    }
  };

  showFaqModal() {
    $("#faq_referral_contest_modal_overlay").fadeIn("fast", function () {
      $("#faq_referral_contest_modal").fadeIn("fast", function () {
        document.body.style.overflow = "hidden";
      });
    });
  };

  onCopied(value) {
    this.setState({
      copied: value
    }, () => {
      if (this.state.copied) {
        setTimeout(() => this.onCopied(!value), 1000);
      }
    });
  };

  render() {
    return (
      <div>
        <FaqReferralContestModal
          textosShow={this.props.textosShow}
          getHeadersToSend={this.props.getHeadersToSend}
          getLanActual={this.props.getLanActual}
          urlGlobal={this.props.urlGlobal}></FaqReferralContestModal>
        <div
          className='content'
          id='game_ui'>
          <div className='wrapper'>
            <SmokeCenter></SmokeCenter>
            <div className='page_content'>
              <div className='c_center'>
                <div className='c_top'>
                  <div className='c_bottom'>
                    <Eagle></Eagle>
                    <Leaves></Leaves>
                    <div className='page_block'>
                      {
                        this.state.referralContest ? (
                          <Container fluid className='game_ui px-0 mx-0'>
                            <Row>
                              <Col className='game_stat'>
                                {this.props.textosShow.juego || "Juego"}: <span>
                                  {this.props.textosShow.competenciareferido || "Competencia referidos"}
                                </span>
                                <br />
                                {this.props.textosShow.iddeljuego || "ID del Juego"}: <span>
                                  {this.state.referralContest.id}
                                </span>
                                <br />
                                <button
                                  className='faq_info mt-1'
                                  onClick={this.showFaqModal.bind(this)}>
                                  FAQ
                                </button>
                              </Col>
                              <Col>
                                <div className="tour_info reamaining text-white w-100 text-center">
                                  {
                                    !this.state.referralContest.closed ? (
                                      <span>
                                        {this.props.textosShow.tiemporestante || "Tiempo restante"}:
                                        {
                                          this.state.referralContest.tiempo.highlight ? (
                                            <span className="iconTimeRemaining pr-1 ml-2">
                                              <FontAwesomeIcon
                                                icon={faHourglassEnd}
                                                size="lg" />
                                            </span>
                                          ) : (
                                            <span className="iconTimeRemaining pr-1 ml-2">
                                              <FontAwesomeIcon
                                                icon={faHourglassHalf}
                                                size="lg" />
                                            </span>
                                          )
                                        }
                                        <h4 className="remaining_time pt-3">
                                          {this.state.referralContest.tiempo.dias}d {this.state.referralContest.tiempo.horas}:{this.state.referralContest.tiempo.minutos}:{this.state.referralContest.tiempo.segundos}
                                        </h4>
                                      </span>
                                    ) : (
                                      <h4 className="remaining_time pt-3">
                                        {this.props.textosShow.termino || "Finalizado"}
                                      </h4>
                                    )
                                  }
                                </div>
                              </Col>
                              <Col className='game_status'>
                                <div className="text-right">
                                {this.props.textosShow.estadodeljuego || "Estado del Juego"}:
                                </div>
                                {
                                  !this.state.referralContest.close ? (
                                    <img
                                      src={waitIcon}
                                      alt={this.props.textosShow.enespera || "En espera"} />
                                  ) : (this.state.referralContest.players.length &&
                                    this.state.referralContest.players[0].jugadorpro.id === this.props.userData.id) ? (
                                    <img
                                      src={winIcon}
                                      alt={this.props.textosShow.ganador || "Ganador"} />
                                  ) : (
                                    null
                                  )
                                }
                              </Col>
                            </Row>
                            <div className='game_main'>
                              <div className='game_icon_main'>
                              </div>
                            </div>
                            <div className='premio mt-4 mt-md-5'>
                              <h5>
                                {this.props.textosShow.premiototal || "Premio Total"}
                              </h5>
                              <div>
                                {this.props.defaultData.moneda.signo} {this.state.referralContest.dinero}
                              </div>

                              {!this.state.referralContest.registered ? (
                                <button className='button button_regular mt-3' onClick={this.showAceptGeneralJackpot.bind(this, this.state.referralContest)}>
                                  {this.props.textosShow.inscribirse || "Inscribirse"}
                                </button>
                              ) : (null)
                              }
                            </div>
                            {this.props.loggedIn ? (
                              <Card
                                className="bg-semitransparent shadow"
                                style={this.state.referralContest.registered ? { marginTop: '-50px' } : {marginTop: '20px'}}>
                                <Container fluid className="py-1">
                                  <Row className="align-items-center">
                                    <Col className="d-block d-sm-flex align-items-center justify-content-between">
                                      <h3 className="ml-sm-2 my-0 text-center">
                                        {this.props.textosShow.referidossharelink || "Share Link"}:
                                      </h3>
                                      <div className="ml-sm-2 mr-sm-auto my-3 my-sm-0 text-center text-success referral-link text-green-gradient">
                                        {`${window.location.origin}/?ref=${this.props.userData.id}`}
                                      </div>
                                      <div className="ml-sm-2 referral-link text-white text-center text-sm-left">
                                        <CopyToClipboard
                                          text={`${window.location.origin}/?ref=${this.props.userData.id}`}
                                          onCopy={() => this.onCopied(true)}>
                                          <button className="pulse cursor-pointer rounded press copy-link-button">
                                            <FontAwesomeIcon icon={faCopy} />
                                          </button>
                                        </CopyToClipboard>
                                        <div className={`position-absolute copied ${this.state.copied ? 'd-block' : 'd-none'}`}>
                                          {this.props.textosShow.copied || "Copied!"}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Container>
                              </Card>
                            ) : null}
                          </Container>
                        ) : (
                          null
                        )
                      }
                      {
                        this.state.referralContest ? (
                          <div className='game_ui_list'>
                            <table>
                              <tbody>
                                {
                                  this.state.referralContest.players.map((player, index) =>
                                    <tr
                                      className={(player.jugador.id === this.props.userData.id) ? 'tr_winner' : ''}
                                      key={player.posicion}>
                                      <td className='dark_td td_num'>
                                        <span>
                                          {player.posicion}
                                        </span>
                                      </td>
                                      <td className='td_win'>
                                        {
                                          player.jugador.id ? (
                                            <div className='select'>
                                              <button
                                                className='main-item'
                                                style={{
                                                  color: '#ffffff'
                                                }}>
                                                <div className='country'>
                                                  <img
                                                    src={player.jugador.pais}
                                                    alt="" />
                                                </div>
                                                {player.jugador.nick}
                                                {
                                                  player.jugador.blocked ? (
                                                    <>
                                                      <span
                                                        data-tip
                                                        data-for={`blocked-tooltip-${player.jugador.id}`}
                                                        className="iconInfo pl-1">
                                                        <FontAwesomeIcon icon={faLock} />
                                                      </span>
                                                      <ReactTooltip id={`blocked-tooltip-${player.jugador.id}`}>
                                                        <p>
                                                          {this.props.textosShow.usuariobloqueado || "Usuario Bloqueado"}
                                                        </p>
                                                      </ReactTooltip>
                                                    </>
                                                  ) : (
                                                    null
                                                  )
                                                }
                                              </button>
                                              {this.props.loggedIn ? (
                                                <ul className="sub-menu lang_menu">
                                                  <li>
                                                    <span
                                                      className="link-button"
                                                      onClick={() => this.props.showPerfilUserModal(player.jugador.id)}>
                                                      {this.props.textosShow.verperfil || "Ver perfil"}
                                                    </span>
                                                    {
                                                      (player.jugador.id !== this.props.userData.id) ? (
                                                        <span
                                                          className="link-button"
                                                          onClick={() => this.props.showChallengeModal(player.jugador.id)}>
                                                          {this.props.textosShow.desafiar || "Desafiar"}
                                                        </span>
                                                      ) : (
                                                        null
                                                      )
                                                    }
                                                  </li>
                                                </ul>
                                              ) : null}
                                            </div>
                                          ) : (
                                            null
                                          )
                                        }
                                        {
                                          (this.state.referralContest.closed && player.posicion === 1) ? (
                                            <div
                                              style={{
                                                color: '#a1e970',
                                                float: 'right'
                                              }}>
                                              {this.props.textosShow.ganador || "Ganador"}
                                            </div>
                                          ) : (
                                            null
                                          )
                                        }
                                      </td>
                                      <td className='dark_td td_pts'>
                                        {
                                          player.jugador.id ? (
                                            <span>
                                              {player.puntos} {this.props.textosShow.referidos || "Referidos"}
                                            </span>
                                          ) : (
                                            null
                                          )
                                        }
                                      </td>
                                      <td className='td_award'>
                                        <span>
                                          {this.props.defaultData.moneda.signo} {player.dinero}
                                          <small className="tour_add">
                                            + {player.gemas}
                                          </small>
                                        </span>
                                      </td>
                                    </tr>
                                  )
                                }
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          null
                        )
                      }
                      <div className='game_ui_warn'>
                        <span>
                          <img
                            src={warningIcon}
                            alt="Warning" />
                          {this.props.textosShow.importantenuestrosistemaalineamatchconoponentesdelmismonivel || "Importante! Nuestro sistema alinea match con openentes del mismo nivel"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
};

export default ReferralContest;
